import { ThemeClassName, themeClassName } from "../utils/theme";

export interface NavLogoConfig {
  /** Tailwind width class for the expanded nav logo container */
  containerClass: string;
  width: number;
  height: number;
}

export interface ThemeAssets {
  /** Light-bg wordmark for Clerk auth cards */
  clerkLogoUrl?: string;
  /** Expanded sidebar nav logo sizing; falls back to platform defaults */
  navLogo?: NavLogoConfig;
}

const defaultNavLogo: NavLogoConfig = {
  containerClass: "w-20",
  width: 84,
  height: 28,
};

/**
 * Per-theme asset URLs and layout sizing. Add an entry when onboarding a brand.
 * Themes without an entry use platform defaults (no Clerk logo override, default nav size).
 */
const themeAssets: Partial<Record<ThemeClassName, ThemeAssets>> = {
  carson: {
    clerkLogoUrl: "/carson-light.png",
  },
  itexchangenet: {
    clerkLogoUrl: "/itexchangenet-light.png",
    navLogo: {
      containerClass: "w-36",
      width: 140,
      height: 36,
    },
  },
};

export function getThemeAssets(
  theme: ThemeClassName = themeClassName(),
): ThemeAssets {
  return themeAssets[theme] ?? {};
}

/** Clerk card logo for the current (or given) theme, if any. */
export function clerkLogoImageUrl(
  theme: ThemeClassName = themeClassName(),
): string | undefined {
  return getThemeAssets(theme).clerkLogoUrl;
}

/** Expanded nav logo sizing for the current (or given) theme. */
export function getNavLogoConfig(
  theme: ThemeClassName = themeClassName(),
): NavLogoConfig {
  return getThemeAssets(theme).navLogo ?? defaultNavLogo;
}
